import { render, staticRenderFns } from "./submitSuccess.vue?vue&type=template&id=38137a4c&scoped=true"
import script from "./submitSuccess.vue?vue&type=script&lang=js"
export * from "./submitSuccess.vue?vue&type=script&lang=js"
import style0 from "./submitSuccess.vue?vue&type=style&index=0&id=38137a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38137a4c",
  null
  
)

export default component.exports